import React, { Component } from 'react';
import QuizinatorTrueFalse from './QuizinatorTrueFalse';
import QuizinatorSelect from './QuizinatorSelect';
import QuizinatorSelectMulti from './QuizinatorSelectMulti';
import QuizinatorWeighted from './QuizinatorWeighted';
import QuizinatorPickOne from './QuizinatorPickOne';
import QuizinatorText from './QuizinatorText';
import QuizinatorTextBlock from './QuizinatorTextBlock';
import QuizinatorInfo from './QuizinatorInfo';
import QuizinatorNum from './QuizinatorNum';

class Questions extends Component {
    render() {
        let quiz = this.props.quiz,
            question = quiz.questions[this.props.currentQuestionIndex];

        // Intro text logic: show after the first two questions, hide for last 3
        let introTop = null;
        const totalQuestions = quiz.questions.length;
        const isInLastThree = this.props.currentQuestionIndex >= Math.max(totalQuestions - 3, 0);

        // if (!isInLastThree && this.props.currentQuestionIndex > 1) {
        //     introTop = 'Great. We look forward to assist you in your therapeutic journey with your counsellor. Take a moment to appreciate that you are reaching out for help to change your life for the better.';
        // }

        switch(question.type){
            case 'TRUE_FALSE': return (
                <QuizinatorTrueFalse
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    answers={this.props.answers}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                    introText={introTop}
                />
            );
            case 'PICK_ONE': return (
                <QuizinatorPickOne
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    answers={this.props.answers}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                    introText={introTop}
                />
            );
            case 'SELECT': return (
                <QuizinatorSelect
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    answers={this.props.answers}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                    introText={introTop}
                />
            );
            case 'SELECTMULTI': return (
                <QuizinatorSelectMulti
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    answers={this.props.answers}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                    introText={introTop}
                />
            );
            case 'WEIGHTED': return (
                <QuizinatorWeighted
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    answers={this.props.answers}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                    introText={introTop}
                />
            );
            case 'TEXT': return (
                <QuizinatorText
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    placeholder={question.placeholder || null}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                />
            );
            case 'TEXTBLOCK': return (
                <QuizinatorTextBlock
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    placeholder={question.placeholder || null}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                />
            );
            case 'NUMBER': return (
                <QuizinatorNum
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    placeholder={question.placeholder || null}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                />
            );
            case 'INFO': return (
                <QuizinatorInfo
                    submitAnswer={this.props.submitAnswer}
                    quiz={this.props.quiz}
                    answers={this.props.answers}
                    currentQuestionIndex={this.props.currentQuestionIndex}
                    buttonsDisabled={this.props.buttonsDisabled}
                    transitionDelay={this.props.transitionDelay}
                />
            );
            default: return null;
        }
    }
}

export default Questions;